/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import './TemplateInstanceCancellationDialog.scss';

import { useReactiveVar } from '@apollo/client';
import * as React from 'react';

import { cancellationDialogDataVar } from '../../../apollo/reactiveVariables/TemplateInstanceVariables';
import { getAppHost } from '../../../utilities/TeamsUtils';
import { ConfirmationDialog, ConfirmationDialogProps } from '../../common/ConfirmationDialog';

export const TemplateInstanceCancellationDialogContainer: React.FC = (): JSX.Element => {
    const dialogData = useReactiveVar(cancellationDialogDataVar);
    const loc = getAppHost().getLocale();

    const onDiscardClick = (): void => {
        cancellationDialogDataVar({ isOpen: false });
        dialogData.discardCallback();
    };

    const onKeepEditingClick = (): void => {
        cancellationDialogDataVar({ isOpen: false });
    };

    const dialogProps: ConfirmationDialogProps = {
        isOpen: dialogData.isOpen,
        title: loc.strings.template_instance_confirmation_dialog_title,
        dismiss: onKeepEditingClick,
        content: (
            <span className='template-instance-dialog-content'>
                {loc.strings.template_instance_confirmation_dialog_content}
            </span>
        ),
        actions: [
            {
                text: loc.strings.discard,
                onClick: onDiscardClick,
            },
            {
                text: loc.strings.keep_editing,
                onClick: onKeepEditingClick,
                primary: true,
            },
        ],
        showDarkOverlay: true,
    };

    return <ConfirmationDialog {...dialogProps} />;
};
